import { Help } from '@carbon/icons-react';
import {
  Header,
  HeaderName,
  Theme,
  SkipToContent,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderContainer,
} from '@carbon/react';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import AppLogo from 'assets/v3/app_logo.png';
import HorizontalLogo from 'assets/v3/horizontal_logo.svg';
import { toLanguageCode } from 'i18n';

import LanguageSelector from './LanguageSelector';
import { Logo } from './Logo';
import './Navbar.scss';

const Navbar = ({
  options,
}) => {
  const {
    showCompanyLogo = true,
    showDocs = true,
  } = options || {};
  const { t, i18n } = useTranslation();
  const profileQuery = null;

  return (
    <div id='navbar-container' className='container'>
      <HeaderContainer
        render={() => (
          <>
            <Theme theme='g100'>
              <Header aria-label='Skydeck'>
                <SkipToContent />
                {showCompanyLogo && (
                  <div className='company-logo-wrapper'>
                    <Logo
                      className='company-logo'
                      logoUrl={profileQuery.data?.data?.account?.logo ?? AppLogo}
                      altText={t('Company logo')}
                    />
                  </div>
                )}
                <HeaderName
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://skydeck.ai/'
                  prefix=''>
                  <div className='logo-group'>
                    <img className='app-logo' src={AppLogo} alt={t('SkyDeck.ai GenStudio')} />
                    <img
                      className='horizontal-logo'
                      src={HorizontalLogo}
                      alt={t('SkyDeck.ai GenStudio')}
                    />
                  </div>
                </HeaderName>
                <HeaderGlobalBar>
                  <LanguageSelector />
                  {showDocs && (
                    <div className='documentation'>
                      <HeaderGlobalAction
                        aria-label={t('SkyDeck.ai documentation')}
                        onClick={() =>
                          window.open(`https://docs.skydeck.ai/v/${toLanguageCode(i18n.language)}`)
                        }>
                        <Help size={20} aria-label='Help' />
                      </HeaderGlobalAction>
                    </div>
                  )}

                </HeaderGlobalBar>
              </Header>
            </Theme>
          </>
        )}
      />
    </div>
  );
};

Navbar.propTypes = {
  options: PropTypes.object,
};

export default memo(Navbar);
